import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import compose from 'recompose/compose';
import { reduxForm, Form } from 'redux-form';
import { ACCEPTANCE_CANDIDATES } from '../../../../../define/consts/solution';
import { propBool, propFunc } from '../../../../../helpers/custom-prop-types';
import { Selectboxes } from '../../../../Ui/FormFields';
const FormChangeAcceptance = ({ disabled, handleSubmit }) => (_jsx(Form, Object.assign({ onSubmit: () => { } }, { children: _jsx(Selectboxes, { disabled: disabled, name: 'acceptance', onChange: handleSubmit, options: ACCEPTANCE_CANDIDATES }) })));
FormChangeAcceptance.propTypes = {
    disabled: propBool().isRequired,
    handleSubmit: propFunc().isRequired,
};
// the name of redux-form must be dynamically assigned
const enhance = compose(reduxForm());
export default enhance(FormChangeAcceptance);
